import { render } from "./dashboard-financial.vue?vue&type=template&id=64745f3f"
import script from "./dashboard-financial.vue?vue&type=script&lang=js"
export * from "./dashboard-financial.vue?vue&type=script&lang=js"

import "./dashboard-financial.vue?vue&type=style&index=0&id=64745f3f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__